export default __webpack_public_path__ + "static/Principle-flow-e5f2991b5b72ff57e3d3969d96143f90.png";